import React from 'react'
import UserGreenIcon from '../../../Common/svg/usergreenicon'
import PhoneIcon from '../../../Common/svg/phoneicon'
import LocationSvg from '../../../Common/svg/locationGray'
import StoreIconSide from '../../../Common/svg/storeiconside'
import { formatPrice } from '../../../../utils/formatPrice'
import StatusBadge from '../statusbadge'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { updateOrders } from '../../../../MyApi/orders'
import usePusher from '../../../../utils/usepusher'


const MultistoreChildren = ({ children , refetch ,id}) => {


  const actionLabelMap = {
  pending: "تأكيد الطلب",
  confirmed: "بدء التجهيز",
  processing: "جاهز للاستلام",
  ready_for_delivery: "في طريق للتوصيل",
  on_the_way: "تأكيد التسليم",
};

    const statusMap = {
    pending: "confirmed",
    confirmed: "processing",
    processing:"ready_for_delivery",
    ready_for_delivery: "on_the_way",
    on_the_way: "delivered",
  };
const queryClient =useQueryClient()
  const mutation = useMutation({
    mutationKey: ["updateOrder"],
    mutationFn: ({ postData, childId }) => updateOrders(postData, childId),
    onSuccess:(data )=>{
  
      toast.success(`${data.message}`)
       refetch()
    },
  onError: (error) => {
    toast.error(error.response?.data?.message || "حدث خطأ ما");
  },
  });



  const handleUpdateOrder = (childId, newStatus) => {
    const status = statusMap[newStatus] ||newStatus
    const postData = { status ,"_method":"PUT"}
    mutation.mutate({ postData, childId })
  }


  if (!children || children.length === 0) {
    return null
  }

  return (
    <div className="col-md-12">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <h5 className="text-smoke font16 font700 mb-3">متاجر متعددة</h5>
          <div className="row">
            {children.map((child, index) => {
              const factor = child.pricing.currency_factor
              const total_amount = formatPrice(factor, child.pricing.total_amount)
              const final_amount = formatPrice(factor, child.pricing.final_amount)
              const service_fee = formatPrice(factor, child.pricing.service_fee)
              const tax_amount = formatPrice(factor, child.pricing.tax_amount)
              const delivery_fee = formatPrice(factor, child.pricing.delivery_fee)
              const discount_amount = formatPrice(factor, child.pricing.discount_amount)
              const paid_amount = formatPrice(factor, child.pricing.paid_amount)
              const tip_amount = formatPrice(factor, child.pricing.tip_amount)

              return (
                <div key={child.id} className="col-lg-6 col-12 mb-3">
                  <div className="card rounded-3 border">
                    <div className="card-body">
                      {/* Store Information */}
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div className='text-green'>
                          <StoreIconSide />

                        </div>

                        <h6 className="text-smoke font14 font700">متجر: {child.store?.name}</h6>
                      </div>
                          <div className='font14 font700  '>رقم الطلب  :{child.order_number}</div>
                         <div className="d-flex justify-content-between align-items-center ">
                                    <div>
                                      <h5 className="mb-3 font14">حالة الطلب</h5>
                                             <StatusBadge status={child.status.value} />
                                    </div>
                                    <div className="d-flex gap-3">
                                    {child.status.value ==="delivered" ||child.status.value ==="cancelled"?null:  <button className="btn btn-sm  btn-primary" onClick={()=>handleUpdateOrder( child.id, child.status.value)}   disabled={mutation.isLoading}>  {mutation.isLoading ? "جاري التحديث..." : actionLabelMap[child.status.value]}</button>}
                                     {child.status.value ==="delivered"||child.status.value ==="cancelled"?null: <button className="btn btn-sm  btn-danger" onClick={()=>handleUpdateOrder(  child.id, "cancelled")}   disabled={mutation.isLoading}>إلغاء الطلب</button>}
                                    </div>
                                  </div>
                      <ul className="d-flex flex-column gap-2 mb-3 mt-3">
                        <li className="d-flex align-items-center gap-1">
                          <PhoneIcon />
                          <span className='text-smoke'>{child.store?.phone}</span>
                        </li>
                        <li className="d-flex align-items-center gap-1">
                          <LocationSvg />
                          <span className='text-smoke'>{child.store?.address}</span>
                        </li>
                      </ul>

                      {/* Items Table */}
                      <h6 className="text-smoke font14 font700 mb-2">عناصر الطلب</h6>
                      <table className="table table-sm">
                        <thead className="border-b border-gray-200">
                          <tr>
                            <th className="py-1 px-1">المنتج</th>
                            <th className="py-1 px-1">الكمية</th>
                            <th className="py-1 px-1">السعر</th>
                            <th className="py-1 px-1">المجموع</th>
                          </tr>
                        </thead>
                        <tbody>
                          {child.items?.map((item, itemIndex) => {
                            const total_price = formatPrice(factor, item.total_price)
                            const unit_price = formatPrice(factor, item.unit_price)
                            return (
                              <tr key={itemIndex} className="border-b border-gray-100">
                                <td className="py-1 px-1">
                                  {item?.product?.name}
                                  {item.selected_options && (
                                    <div className="text-green">{item.selected_options}</div>
                                  )}
                                  <div className="fw-bold">{item?.product?.options?.map((option)=>(<div key={option.id}>خيارات{option.name}</div>))}</div>
                                </td>
                                <td className="py-1 px-1">{item.quantity}</td>
                                <td className="py-1 px-1">
                                  {item.symbol_currency}
                                  {unit_price}
                                </td>
                                <td className="py-1 px-1">
                                  {item?.symbol_currency}
                                  {total_price}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>

                      {/* Pricing Summary */}
                      <div className="text-right w-100 mt-2">
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">المجموع الفرعي</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {total_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">رسوم التوصيل</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {delivery_fee}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">تكلفة الخدمة</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {service_fee}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">الضريبة</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {tax_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">الخصم</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {discount_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">المبلغ المدفوع</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {paid_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100">
                          <span className="text-smoke">المبلغ الإضافي</span>
                          <span className="text-smoke">
                            {child.pricing.symbol_currency}
                            {tip_amount}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between w-100 fw-bold mt-2">
                          <span className="fw-bold">الإجمالي</span>
                          <span className="fw-bold text-green">
                            {child.pricing.symbol_currency}
                            {final_amount}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MultistoreChildren